import TagManager from 'react-gtm-module'

export const gaAudioButton = (_src, _action) => {
    // console.log(_src);
    // console.log(_action)
    const tagManagerArgs = {
        dataLayer: {
            event: 'audio',
            audioPlayerAction: _action,
            audioSrc: _src,
            audio_provider: "react-h5-audio-player",
            audioTitle: 'webinar snippets audio'
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);

};

export const gaVideoButton = (_src, _action) => {
    // console.log(_src);
    // console.log(_action)
    const tagManagerArgs = {
        dataLayer: {
            event: 'video',
            videoPlayerAction: _action,
            videoSrc: _src,
            video_provider: "video-player",
            videoTitle: _src
        },
        dataLayerName: 'dataLayer'
    }
    console.log(tagManagerArgs);
    TagManager.dataLayer(tagManagerArgs);

};

export const gaMenuButtonClick = (_selectionID, _title) => {
    const tagManagerArgs = {
        dataLayer: {
            event: 'menu',
            menuAction: 'click',
            menuSelect: _selectionID,
            menuTitle: _title
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);
    console.log(tagManagerArgs);
};
export const gaRegistrationButtonClick = () => {
    const tagManagerArgs = {
        dataLayer: {
            event: 'registration',
            action: 'click',
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);
    
};
export const gaTranscriptButtonClick = (_mode) => {
    // console.log(_mode)
    const tagManagerArgs = {
        dataLayer: {
            event: 'transcript',
            action: 'click',
            mode: _mode
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);
    
};

export const gaAudioProgress = (_percent, _audiofile) => {
    // console.log(`audio_percent: ${_percent} - audio_title: ${_audiofile}`)
    const tagManagerArgs = {
        dataLayer: {
            event: 'audio',
            audioPlayerAction: 'Progress %' + _percent,
            audio_percent: _percent,
            audio_provider: "react-h5-audio-player",
            audioTitle: 'webinar snippets audio'
        },
        dataLayerName: 'dataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);

};

export const gaVideoProgress = (_percent, _videofile) => {
    // console.log(`audio_percent: ${_percent} - audio_title: ${_videofile}`)
    const tagManagerArgs = {
        dataLayer: {
            event: 'video',
            videoPlayerAction: 'Progress %' + _percent,
            video_percent: _percent,
            video_provider: "video-player",
            videoTitle: _videofile
        },
        dataLayerName: 'dataLayer'
    }
    console.log(_videofile);
    TagManager.dataLayer(tagManagerArgs);

};

